
import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import CommunicationErrorsLog from '../../components/CommunicationError/CommunicationErrorLog';
const defaultTheme = createTheme();
const CommunicationErrorSLog = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <CommunicationErrorsLog/>
    </ThemeProvider>
  )
}

export default CommunicationErrorSLog